import { get } from 'object-path-immutable';
import {
  addTheme as addTextTheme,
  overrides as textOverrides,
  extractStyles as extractTextStyles,
} from './text';
import {
  calculateOverridePaths,
  styleToThemeStyle,
  augmentedWrap,
} from './utils';

const PATHS = {
  root: 'style',
  errorLabel: 'errorLabel',
  label: 'label',
  placeholder: 'placeholder',
  textField: 'textFieldStyle',
};

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  augmentedWrap(content)
    .set(
      PATHS.errorLabel,
      addTextTheme(content.errorLabel, `${selectedVariant}.errorLabel`)
    )
    .set(PATHS.label, addTextTheme(content.label, `${selectedVariant}.label`))
    .set(
      PATHS.placeholder,
      addTextTheme(content.placeholder, `${selectedVariant}.placeholder`)
    )
    .updateStyle(PATHS.root, { theme: selectedVariant }, preserveOverrides)
    .updateStyle(
      PATHS.textField,
      { theme: `${selectedVariant}.textField` },
      preserveOverrides
    )
    .value();

export const overrides = ({ compiledTheme, content }) =>
  [
    calculateOverridePaths({ compiledTheme, content, path: PATHS.root }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.label,
      pathName: 'label',
    }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.errorLabel,
      pathName: 'errorLabel',
    }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.placeholder,
      pathName: 'placeholder',
    }),
    calculateOverridePaths({
      compiledTheme,
      content,
      path: PATHS.textField,
      pathName: 'textField',
    }),
  ].flat();

export const extractStyles = content => ({
  $style: styleToThemeStyle({ style: get(content, PATHS.root) }),
  label: extractTextStyles(get(content, PATHS.label)),
  errorLabel: extractTextStyles(get(content, PATHS.errorLabel)),
  placeholder: extractTextStyles(get(content, PATHS.placeholder)),
  textField: {
    $style: styleToThemeStyle({ style: get(content, PATHS.textField) }),
  },
});
